import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

type ProductCardProps = React.PropsWithChildren<{
  icon: React.ReactNode;
  title: string;
  className?: string;
}>;

const ProductCard = ({
  icon,
  title,
  children,
  className,
}: ProductCardProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col rounded-2xl border-0.5 border-border shadow-sm",
        className,
      )}
    >
      <div className="flex items-center gap-2 p-5 border-b-0.5 border-border">
        {icon}
        <span className="text-base font-medium">{title}</span>
      </div>
      <div className="flex flex-col">{children}</div>
    </div>
  );
};

export default ProductCard;
